/** USD display and Stripe `unit_amount` (cents) — single source of truth. */
export const DO_OR_DUMP_UPSELL_NICHE = {
  id: "niche_insight",
  label: "Expert audit & 10 minutes of your questions (human)",
  /** Body copy only — show turnaround separately in UI (bold). */
  detail:
    "Human-written. After checkout you send one voice memo (~10 minutes) with your questions. You get a written audit of your Do or Dump snapshot, answers to what you asked, and a straight take on what you said.",
  turnaround: "1–3 business days",
  amountUsd: 29.99,
  unitAmountCents: 2999,
} as const;

/** Second add-on: private async thread + 30-day plan (replaces former AI PDF offering). */
export const DO_OR_DUMP_UPSELL_BUSINESS_PUSH = {
  id: "business_push_30",
  label: "30-day business push",
  /** Body copy only — show turnaround separately in UI (bold), same pattern as Expert Audit. */
  detail:
    "Human-written. After checkout we build from your Do or Dump snapshot: a written review, a simple 30-day action plan, and a private async thread for questions. Weekly check-ins land in that thread through your window — no calls.",
  turnaround: "Plan within a few business days; private chat stays open through your 30-day window.",
  amountUsd: 99.99,
  unitAmountCents: 9999,
} as const;

/** Stripe line item description (plain text). */
export function upsellStripeDescription(u: { detail: string; turnaround: string }): string {
  return `${u.detail}\n\nTurnaround: ${u.turnaround}`;
}
